module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("From Colonial Times to the Naval Torpedo Station")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0003.jpg",
      "src": "images/e9781439631850_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Newport in colonial times. This map of Newport in the Province of Rhode Island includes an early layout of the settlement, streets, and dock areas. Goat Island (in the center foreground) later takes on prominence as the site of military forts for the protection of the harbor and, still later, becomes the location of a post-Civil War naval station.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0004.jpg",
      "src": "images/e9781439631850_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Newport harbor in the mid-nineteenth century. From early colonial times, Newport bustled with maritime activity, both commercial and military.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "39%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0005.jpg",
      "src": "images/e9781439631850_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Islands near Newport. This map of Narragansett Bay near Aquidneck Island from "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Newport Begins")]), _vm._v(" by L.A. Robson (Newport Historical Society) details the East Passage and shows the relationship of Newport to Goat Island, site of the navy’s first experimental torpedo station in 1869 and Coasters Harbor Island, where the Naval Training Station and Naval War College began in 1883–1884. Other nearby islands were used over the years by the navy, particularly during World War I and World War II.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0006.jpg",
      "src": "images/e9781439631850_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Commander of the first navy. On December 22, 1775, Rhode Island’s Esek Hopkins was commissioned the first “Commander in Chief of the Fleet of the United Colonies.” Hopkins was thus commander of America’s first navy. Esek’s son, John Hopkins, was captain of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cabot")]), _vm._v(" in the first Continental fleet; another Rhode Islander, Abraham Whipple, commanded the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Columbus")]), _vm._v(" for the Colonies. (Brown University Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0007.jpg",
      "src": "images/e9781439631850_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Katy")]), _vm._v(", 1775. A Rhode Island Navy sloop, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Katy")]), _vm._v(" became one of the five ships in America’s first navy—the newly established Continental fleet. Renamed the USS "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Providence")]), _vm._v(" in the Revolutionary War, it was the first command of John Paul Jones. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Newport Navalog")]), _vm._v(".)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0008.jpg",
      "src": "images/e9781439631850_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Plan of the Town of Newport in 1777. Goat Island, prominently shown in the foreground, became the site of the first official U.S. Naval Research Station, established nearly a century later in 1869. Fort George (shown on the island) was set up in pre-Revolutionary times to protect the harbor entrance to Newport. It underwent several name changes reflecting the reigning British monarchs and political shifts in colonial times and the early republic.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0009.jpg",
      "src": "images/e9781439631850_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("General Lafayette in Rhode Island. In September 1778, the Marquis de Lafayette—whom the Continental Congress had made a major general at George Washington’s request—took command of the ports within the Island of Rhode Island. Entrusted with the care of Warren, Bristol, and “the eastern shore” (Newport was in British hands), General Lafayette made his headquarters first in Bristol and then at “a safer place behind Warren.” For the 200th anniversary (1978) of Lafayette’s tour of duty in Rhode Island, Bristol artist R.V. Simpson created a commemorative cover. Franked with a Lafayette U.S. Bicentennial stamp, the philatelic item is shown here (in black and white) with a special Bristol cancellation. (Author’s collection.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0010.jpg",
      "src": "images/e9781439631850_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Coasters Harbor Island, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1832. The offshore island where the founders of the City by the Sea landed in 1639 is two miles north of the center of Newport. In 1883, a Naval Training Station was established on the island, and the next year, in 1884, the Newport Alms House (shown above) became the first home of the Naval War College. The Alms House, an asylum for the poor, was built by Benjamin Chase of Newport, chiefly of fieldstone from the island, at a cost of $6,940. Work on the building began in 1817 and was completed in March 1820. (Naval War College Museum.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_net"
  }, [_c('div', {
    staticClass: "image_net",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0011.jpg",
      "src": "images/e9781439631850_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("George S. Blake (1803–1871) as superintendent of the U.S. Naval Academy. When the Civil War threatened, Blake sought the help of Secretary of the Navy Gideon Welles. With secessionist sympathy fairly high in the border state of Maryland, Blake recommended prompt removal of the academy, staff, and students to a safer location. He also believed that the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Constitution")]), _vm._v(", assigned to Annapolis as a school ship, should be saved from possible Confederate capture and exploitation. On April 27, 1861, Secretary Welles approved the academy’s removal from Newport, Rhode Island. (U.S. Naval Academy Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0012.jpg",
      "src": "images/e9781439631850_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("USS "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Constitution")]), _vm._v(". This historic ship, known as “Old Ironsides” and assigned to the U.S. Naval Academy at Annapolis from 1860–1871, was used to transport midshipmen to Newport when the Civil War threatened. The navy also engaged the steamer "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Baltic")]), _vm._v(" to carry officers, civilian professors, and their families. The ships arrived in Newport on May 9, 1861, and received a 24-gun salute from Fort Adams. (U.S. Naval Academy Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0013.jpg",
      "src": "images/e9781439631850_i0013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Civil War years in Annapolis. The U.S. Naval Academy served as a military hospital, and Union troops occupied the grounds after the staff and midshipmen were removed to Newport, Rhode Island, for safety during the war period. (U.S. Naval Academy Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0014.jpg",
      "src": "images/e9781439631850_i0014.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("C.R.P. Rodgers, a commandant of midshipmen at Newport. Upon arrival in Newport in 1861, Lieutenant (later Admiral) Rodgers became academy superintendent in the absence of Captain George S. Blake, who had remained in Annapolis. (U.S. Naval Academy Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0015.jpg",
      "src": "images/e9781439631850_i0015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("USS "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Constitution")]), _vm._v(" coming to Newport. In this view, “Old Ironsides,” the ship that brought Annapolis to Newport in 1861, is moored at Goat Island in Newport Harbor during the Civil War. It returned to Annapolis in mid-1865.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0016.jpg",
      "src": "images/e9781439631850_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Academy site in Newport. When the U.S. Naval Academy was moved from Annapolis to Newport, the navy selected Fort Adams—at the entrance to Newport Harbor—as the academy’s site. Fort Adams had recently been vacated by the army, but barely half of the navy officers and faculty could be quartered within its old walls. The navy then leased a large, four-story hotel, the Atlantic House on Bellevue Avenue, for the duration of its stay in Newport. Officers quarters and mess were on the ground floor, classrooms on the second, and upperclass midshipmen billets on the top floors. Truro Park, then as now, provides a pleasant recreation area just across the street. This marker designates the site, now home to the Elks Club of Newport, occupied by the academy from 1861–1865. (Darcy Associates, Ltd.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0017.jpg",
      "src": "images/e9781439631850_i0017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("William Thomas Sampson (1840–1902) as a midshipman. A native of Palmyra, New York, and Honor Man of the U.S. Naval Academy Class of 1861, Sampson was an instructor during the academy’s Civil War period in Newport. He later served as superintendent of the academy. (U.S. Naval Academy Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0018.jpg",
      "src": "images/e9781439631850_i0018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("USS "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Santee")]), _vm._v(". In 1862, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Santee")]), _vm._v(" arrived in Newport to support the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Constitution")]), _vm._v(", which was moored at Goat Island. It would serve as a U.S. Naval Academy school ship for the next fifty years. (U.S. Naval Academy Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0019.jpg",
      "src": "images/e9781439631850_i0019.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Members of the U.S. Naval Academy Class of 1864 at Newport, Rhode Island. When the U.S. Naval Academy was removed from Annapolis, Maryland, to Newport during the Civil War, classes went on, and these midshipmen became the first class to graduate during the academy’s stay in Newport. (U.S. Naval Academy Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0020.jpg",
      "src": "images/e9781439631850_i0020.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Naval Torpedo Station, Newport, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1870. On July 29, 1869, the Secretary of War authorized the Navy Department to establish an experimental torpedo station on Goat Island, a 32-acre site in Newport Harbor. Commander E.O. Matthews was designated Commanding Officer and Inspector in Charge. This is the earliest known photograph of the Naval Torpedo Station at Newport. (Naval War College Museum.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0021.jpg",
      "src": "images/e9781439631850_i0021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Naval Torpedo Station, 1873. The first buildings on Goat Island were those formerly used by army personnel who staffed the old fortification. These structures were used by the U.S. Naval Academy that was relocated to Newport during the Civil War. The drawing appeared in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Harper’s Weekly")]), _vm._v(" in 1873.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0022.jpg",
      "src": "images/e9781439631850_i0022.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Newport harbor in 1873. This sketch of the harbor, also from "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Harper’s Weekly")]), _vm._v(", shows the Naval Torpedo Station and Goat Island in front of the Newport shoreline.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0023.jpg",
      "src": "images/e9781439631850_i0023.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Naval Torpedo Station commanders. This plaque lists the names of the military commanders of the Naval Torpedo Station from its inception in 1869 to its disestablishment in 1951. For over seventy years, from 1869 to 1943, this commanding officer was designated “Inspector of Ordnance in Charge.” The title was changed to “Commanding Officer” beginning in 1943. A second plaque (not shown) carries the names of the commanding officers of successor organizations, the Naval Underwater Ordnance Station (1951–1966) and Naval Underwater Weapons Research and Engineering Station (1966–1970).")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631850_i0024.jpg",
      "src": "images/e9781439631850_i0024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Goat Island, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1876. The Navy Department’s first experimental torpedo facility grew rapidly in the first decade after its establishment in Newport harbor in 1869. Later, the Naval Torpedo Station saw heightened activity through two world wars. In the early 1940s, particularly, both its technical research activity and production capacity were expanded to support the fleet. (Naval War College Museum.)")])])])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b886234","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439631850_c01.vue
// module id = 75
// module chunks = 0